import React,{useState,useEffect} from 'react';
export const Comp_Matri_Mem_Status=(props)=>{
    //alert(JSON.stringify(props));
    useEffect(()=>{
//alert(JSON.stringify(props.memberProfile));
    },[props.memberProfile])
        return(<div className="modal fade bd-example-modal-xl"  id="divMemActDecaStatus" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Verified/Unverified</h5>
              <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            {props.memberProfile.length>0?
            <form id="frmMemActDecaStatus" name="frmMemActDecaStatus">
            <div className="modal-body">
            <div className="row">
                      {/* <!-- left column --> */}
                      <div className="col-md-12">
                          <div className="card card-danger">
                                  <input type="hidden" name="res_func" id="res_func" value="okMemberStatus" />
                                  <input type="hidden" name="curl_type" id="curl_type" value="updateMemberStatus" />
                                  <input type="hidden" name="m_type" id="m_type" value="updateMemberStatus" />
                                  <input type="hidden" name="type_id" id="type_id" value="2" />

                                  {/* <input type="hidden" name="product_id" id="product_id" value={typeof props.memberProfile[0].rf_id!=="undefined"?props.editProduct.rf_id:""} /> */}
                                  <input type="hidden" name="account_inf_token" id="account_inf_token" value={btoa(props.memberProfile[0]["account_info_id"])} />
                                  <input type="hidden" name="member_inf_token" id="member_inf_token" value={btoa(props.memberProfile[0]["id"])} />
                                  <input type="hidden" name="local_token" id="local_token" value={props.logInObj[0].app_user_id} />
                                  <div className="card-body">
                                      <div className="row">
                                     
                                          <div className="col-lg-12 col-md-12">
                                              <div className="form-group">
                                                  <label for="exampleInputEmail1">Set Status</label>
                                                  <select  className="form-control form-control-sm required" id="veri_status" name="veri_status">
           <option value="0">-Status-</option>
           <option value="Verified">-Verified-</option>
           <option value="Unverified">-Unverified-</option>
          
         </select>
                                              </div>
                                          </div>
                                      </div>
                                    
                                      <div className="col-md-6 respSSL"></div>
                                      <div id="testing2dd2222"></div>
                                  </div>
                              
                          </div>
                      </div>
                  </div>
            </div>
            <div className="modal-footer">
            <div id="getReponse" style={{color:"red"}}></div>
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" className="btn _btnSetColor btn-primary">Save changes</button>
            </div>
            </form>:''}
          </div>
          </div>
          </div>
      );
}
export default Comp_Matri_Mem_Status;
